/**
 * <recently-viewed> custom element
 *
 * Stores the product currently being viewed (passed via data-current-product
 * as JSON) in localStorage, then renders the most recently viewed cards
 * from history, excluding the current product. Hides itself if history is empty.
 *
 * All product data is captured at view time (URL, title, image, price) so the
 * grid renders instantly with zero network requests.
 */
if (!customElements.get('recently-viewed')) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.max = parseInt(this.dataset.max || '4', 10);
      this.storageKey = this.dataset.storageKey || 'recently_viewed_products';
      this.grid = this.querySelector('[data-grid]');
      this.template = this.querySelector('template[data-card-template]');
    }

    connectedCallback() {
      this.recordCurrent();
      this.render();
    }

    _readHistory() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }

    _writeHistory(arr) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(arr.slice(0, 50)));
      } catch (e) { /* private mode / quota */ }
    }

    recordCurrent() {
      const raw = this.dataset.currentProduct;
      if (!raw) return;
      let data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      if (!data || !data.id) return;
      let history = this._readHistory();
      history = [data, ...history.filter((p) => String(p.id) !== String(data.id))];
      this._writeHistory(history);
      this._currentId = data.id;
    }

    render() {
      if (!this.grid || !this.template) {
        this.hidden = true;
        return;
      }
      let history = this._readHistory();
      // Exclude the current product so the grid never shows what they're already looking at.
      if (this._currentId) {
        history = history.filter((p) => String(p.id) !== String(this._currentId));
      }
      if (!history.length) {
        this.hidden = true;
        return;
      }
      const items = history.slice(0, this.max);
      this.grid.innerHTML = '';
      items.forEach((p) => {
        const node = this.template.content.cloneNode(true);
        const link = node.querySelector('[data-card-link]');
        const img = node.querySelector('[data-card-image]');
        const title = node.querySelector('[data-card-title]');
        const price = node.querySelector('[data-card-price]');
        if (link) link.href = p.url || '#';
        if (img && p.image) {
          img.src = p.image;
          img.alt = p.title || '';
        }
        if (title) title.textContent = p.title || '';
        if (price) price.textContent = p.price || '';
        this.grid.appendChild(node);
      });
      this.hidden = false;
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
}
